var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai rt60"},[_c('div',[_c('banner',{attrs:{"child-data":_vm.fdata}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }